import { render, staticRenderFns } from "./FeeConfigDetailHis.vue?vue&type=template&id=f06bfc76&scoped=true"
import script from "./FeeConfigDetailHis.vue?vue&type=script&lang=js"
export * from "./FeeConfigDetailHis.vue?vue&type=script&lang=js"
import style0 from "./FeeConfigDetailHis.vue?vue&type=style&index=0&id=f06bfc76&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f06bfc76",
  null
  
)

export default component.exports